/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Unknown_LineInputs */

const en_po_issue_unknown_line = /** @type {(inputs: Po_Issue_Unknown_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not a line of this purchase order`)
};

/**
* | output |
* | --- |
* | "is not a line of this purchase order" |
*
* @param {Po_Issue_Unknown_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_unknown_line = /** @type {((inputs?: Po_Issue_Unknown_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Unknown_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_unknown_line(inputs)
});